import { Node } from '@msdyn365-commerce-modules/utilities';
import React from 'react';
import Button from 'reactstrap/lib/Button';

export interface ISeeMoreButtonProps {
    seeMoreBtnAriaLabel: string;
    seeMoreButtonText: string;
    handleSeeMore: (e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> | React.FormEvent<HTMLFormElement>) => void;
}

export const SeeMoreButtonComponent = (props: ISeeMoreButtonProps): JSX.Element => {
    const { seeMoreBtnAriaLabel, seeMoreButtonText, handleSeeMore } = props;
    return (
        <Node className='msc-autoSuggest__see-more-button-wrapper'>
            <Button onClick={handleSeeMore} aria-label={seeMoreBtnAriaLabel} className='msc-autoSuggest__see-more-button'>
                {seeMoreButtonText}
            </Button>
        </Node>
    );
};
